/**
 * Formats a coordinate value into a specific format based on the provided flags.
 *
 * @param value - The coordinate value as a string.
 * @param isLong - A boolean indicating if the value is a longitude in the standard format.
 * @param isLat - A boolean indicating if the value is a latitude in the standard format.
 * @param isLong3 - A boolean indicating if the value is a longitude in the 3-digit format.
 * @param isLat3 - A boolean indicating if the value is a latitude in the 3-digit format.
 * @returns An array of strings representing the formatted coordinate parts.
 */
export const getValueInFormat = (
  value: string,
  isLong: boolean,
  isLat: boolean,
  isLong3: boolean,
  isLat3: boolean,
  isLatLong4?: boolean,
  config?: number[],
) => {
  if (!value) {
    // blank value check !!!!!!!!!
    return ["", "", ""];
  }
  if (!value.split) {
    return ["", "", ""];
  }
  if (value === "") {
    return ["", "", ""];
  }
  const splitted = value.split(" ");
  if (splitted.length === 3) return splitted;

  if (config && config.length === 3) {
    const p1 = config[0];
    const p2 = config[0] + config[1];
    return [
      value.slice(0, p1) ?? "",
      value.slice(p1, p2) ?? "",
      value.slice(p2) ?? "",
    ];
  }

  if (isLatLong4)
    return [
      value.slice(0, 2) ?? "",
      value.slice(2, 4) ?? "",
      value.slice(4) ?? "",
    ];
  if (isLong3)
    return [
      value.slice(0, 3) ?? "",
      value.slice(3, 5) ?? "",
      value.slice(5) ?? "",
    ];
  if (isLong)
    return [
      value.slice(0, 3) ?? "",
      value.slice(3, 6) ?? "",
      value.slice(6) ?? "",
    ];
  if (isLat)
    return [
      value.slice(0, 2) ?? "",
      value.slice(2, 5) ?? "",
      value.slice(5) ?? "",
    ];
  if (isLat3)
    return [
      value.slice(0, 2) ?? "",
      value.slice(2, 4) ?? "",
      value.slice(4) ?? "",
    ];

  return [];
};
